import Vue from 'vue';
import { mapGetters } from 'vuex';
import { stringify } from 'csv-stringify';
import Embeddings from 'src/api/embeddings';
import Utils from 'src/utils/general';
import FormatUtils from 'src/utils/formatters';
import DynamicHighlight from "./DynamicHighlight.vue";
export default Vue.extend({
    components: { DynamicHighlight },
    data() {
        return {
            loading: false,
            results: [],
            fetchedQuery: null,
            query: '' // live query in the search box
        };
    },
    computed: {
        ...mapGetters(['currentProject'])
    },
    methods: {
        number: FormatUtils.number,
        downloadExport() {
            const rows = [["text", "score"]].concat(this.results.map(r => [r.frame._text, r.score]));
            stringify(rows, (_, csvString) => {
                Utils.downloadCsv(csvString, `fuzzy-search-results-${Utils.truncateText(this.fetchedQuery, 25)}`);
            });
        },
        async search() {
            if (this.query.trim().length === 0) {
                this.results = [];
                return;
            }
            this.loading = true;
            try {
                this.fetchedQuery = this.query;
                let r = await Embeddings.search(this.currentProject.id, this.query, 0, 1000);
                this.results = r.hits;
            }
            finally {
                this.loading = false;
            }
        }
    }
});
